import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import "./style.scss";
import { useTranslation } from "react-i18next";

const CardBalance: React.FC = () => {
  const userData = useSelector((state: State) => state.auth.userData);
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {userData.captionDepositBalance !== "0.00" && userData.captionDepositBalance !== null && (
        <h1>
          {userData.captionDepositBalance} {t("zl")}
        </h1>
      )}
      {userData.captionBalanceI !== "0.00" && userData.captionBalanceI !== null && (
        <h1>
          {userData.captionBalanceI} {t("zl")}
        </h1>
      )}
      {userData.captionBalanceII !== "0.00" && userData.captionBalanceII !== null && (
        <h1>
          {userData.captionBalanceII} {t("zl")}
        </h1>
      )}
      {userData.captionBalanceIII !== "0.00" && userData.captionBalanceIII !== null && (
        <h1>
          {userData.captionBalanceIII} {t("zl")}
        </h1>
      )}
      {userData.captionBalanceI === "0.00" &&
        userData.captionBalanceII === "0.00" &&
        userData.captionBalanceIII === "0.00" && <h1>{t("brak_srodkow")}</h1>}
    </React.Fragment>
  );
};

export default CardBalance;
